module.exports = __webpack_public_path__ + "static/media/sudeer.9fdfb0be.jpg";